const organizations = {
    organization: 'المؤسسة',
    page_title: 'المؤسسات',
    title: 'المؤسسات',
    subtitle: 'تستخدم المؤسسات عادة في تطبيقات SaaS أو تطبيقات متعددة المستأجرين المماثلة وتمثل عملائك الذين هم فرق أو مؤسسات أو شركات بأكملها. تعمل المؤسسات كعنصر أساسي للمصادقة والترخيص للأعمال التجارية بين الشركات.',
    organization_template: 'نموذج المؤسسة',
    organization_id: 'معرف المؤسسة',
    members: 'الأعضاء',
    machine_to_machine: 'تطبيقات من الجهاز إلى الجهاز',
    create_organization: 'إنشاء مؤسسة',
    setup_organization: 'إعداد مؤسستك',
    organization_list_placeholder_title: 'المؤسسة',
    organization_list_placeholder_text: 'تستخدم المؤسسات في العادة في تطبيقات SaaS أو تطبيقات متعددة المستأجرين المماثلة كممارسة جيدة. تمكنك من تطوير تطبيقات تسمح للعملاء بإنشاء وإدارة المؤسسات ودعوة الأعضاء وتعيين الأدوار.',
    organization_name_placeholder: 'مؤسستي',
    organization_description_placeholder: 'وصف موجز للمؤسسة',
    organization_permission: 'إذن المؤسسة',
    organization_permission_other: 'أذونات المؤسسة',
    create_permission_placeholder: 'قراءة سجل المواعيد',
    organization_role: 'دور المؤسسة',
    organization_role_other: 'أدوار المؤسسة',
    organization_role_description: 'دور المؤسسة هو تجميع للأذونات التي يمكن تعيينها للمستخدمين. يجب أن تأتي الأذونات من أذونات المؤسسة المحددة مسبقًا.',
    role: 'الدور',
    search_placeholder: 'البحث بواسطة اسم المؤسسة أو المعرف',
    search_role_placeholder: 'اكتب للبحث وتحديد الأدوار',
    empty_placeholder: '🤔 ليس لديك أي {{entity}} معدة حتى الآن.',
    organization_and_member: 'المؤسسة والعضو',
    organization_and_member_description: 'المؤسسة هي مجموعة من المستخدمين ويمكن أن تمثل الفرق والعملاء التجاريين وشركات الشركاء، حيث يكون كل مستخدم عضوًا. يمكن أن تكون هذه الكيانات الأساسية للتعامل مع متطلباتك المتعددة للمستأجرين.',
    guide: {
        title: 'ابدأ بالأدلة',
        subtitle: 'ابدأ إعدادات المؤسسة الخاصة بك مع أدلتنا',
        introduction: {
            title: 'لنفهم كيف تعمل المؤسسة في Logto',
            section_1: {
                title: 'المؤسسة هي مجموعة من المستخدمين (الهويات)',
            },
            section_2: {
                title: 'تم تصميم نموذج المؤسسة للتحكم في وصول التطبيقات متعددة المستأجرين',
                description: 'في تطبيقات SaaS متعددة المستأجرين ، غالبًا ما تشترك المؤسسات المتعددة في نفس نموذج التحكم في الوصول ، والذي يشمل الأذونات والأدوار. في Logto ، نسميه "نموذج المؤسسة".',
                permission_description: 'إذن المؤسسة يشير إلى التصريح بالوصول إلى مورد في سياق المؤسسة.',
                role_description_deprecated: 'دور المؤسسة هو تجميع لأذونات المؤسسة يمكن تعيينها للأعضاء.',
                role_description: 'دور المؤسسة هو تجميع لأذونات المؤسسة أو أذونات واجهة برمجة التطبيقات يمكن تعيينها للأعضاء.',
            },
            section_3: {
                title: 'هل يمكنني تعيين أذونات واجهة برمجة التطبيقات لأدوار المؤسسة؟',
                description: 'نعم ، يمكنك تعيين أذونات واجهة برمجة التطبيقات لأدوار المؤسسة. يوفر Logto المرونة في إدارة أدوار المؤسسة الخاصة بك ، مما يتيح لك تضمين كل من أذونات المؤسسة وأذونات واجهة برمجة التطبيقات ضمن تلك الأدوار.',
            },
            section_4: {
                title: 'تفاعل مع الرسم التوضيحي لرؤية كيفية ربط كل شيء',
                description: 'لنأخذ مثالًا. جون وسارة في مؤسسات مختلفة بأدوار مختلفة في سياق مؤسسات مختلفة. مرر المؤشر فوق الوحدات المختلفة وشاهد ما يحدث.',
            },
        },
        organization_permissions: 'أذونات المؤسسة',
        organization_roles: 'أدوار المؤسسة',
        admin: 'المسؤول',
        member: 'العضو',
        guest: 'الضيف',
        role_description: 'الدور "{{role}}" يشترك في نفس نموذج المؤسسة عبر مؤسسات مختلفة.',
        john: 'جون',
        john_tip: 'جون ينتمي إلى مؤسستين بالبريد الإلكتروني "john@email.com" كمعرف واحد. إنه المسؤول في المؤسسة A وضيف في المؤسسة B.',
        sarah: 'سارة',
        sarah_tip: 'سارة تنتمي إلى مؤسسة واحدة بالبريد الإلكتروني "sarah@email.com" كمعرف واحد. إنها المسؤولة في المؤسسة B.',
    },
};
export default Object.freeze(organizations);
